import type { InitOptions, FallbackLngObjList } from 'i18next';

export const fallbackLng: FallbackLngObjList = {
  en: ['en-GB'],
  'zh-CN': ['zh-Hans'],
  'zh-TW': ['zh-Hant'],
  'zh-HK': ['zh-Hant-HK'],
  // in the case project does not have base language locales
  // we can fall back to a specific regional version
  cs: ['cs-CZ'],
  da: ['da-DK'],
  de: ['de-DE'],
  es: ['es-ES'],
  fr: ['fr-FR'],
  it: ['it-IT'],
  ja: ['ja-JP'],
  nb: ['nb-NO'],
  nl: ['nl-NL'],
  pl: ['pl-PL'],
  pt: ['pt-BR'],
  ru: ['ru-RU'],
  sv: ['sv-SE'],
  zh: ['zh-CN'],
};

const defaultConfig: InitOptions = {
  // https://www.i18next.com/overview/configuration-options
  // allow keys to be phrases having `:`, `.`
  nsSeparator: false,
  keySeparator: false,

  fallbackLng,

  // https://github.com/i18next/i18next-browser-languageDetector#detector-options
  detection: {
    // do not cache user lang or else it won't update when changed in browser settings
    order: ['navigator'],
    caches: [],
  },
};

export default defaultConfig;
